import { render, staticRenderFns } from "./CompanyOrdinaryTimeDialog.vue?vue&type=template&id=55b6b9c7&"
import script from "./CompanyOrdinaryTimeDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyOrdinaryTimeDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrdinaryTimeDialog.vue?vue&type=style&index=0&id=55b6b9c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports